<template>
  <div class="m-tile" :class="{ 'm-tile--done': isDone, 'm-tile--error': state === 'error' }">
    <button class="m-tile__main" @click="onTap">
      <img v-if="thumbUrl" :src="thumbUrl" class="m-tile__thumb" alt="" />
      <div v-else-if="notAvailable" class="m-tile__na">
        <i class="material-icons">block</i>
        <span>{{ $t("returns.photos.notAvailable") }}</span>
      </div>
      <div v-else class="m-tile__empty">
        <i class="material-icons">photo_camera</i>
      </div>

      <span class="m-tile__label">
        {{ label }}
        <em v-if="required && !isDone" class="m-tile__req">{{ $t("returns.photos.required") }}</em>
      </span>

      <span v-if="state === 'uploading'" class="m-tile__state m-tile__state--busy">
        <i class="material-icons m-spin">sync</i>
      </span>
      <span v-else-if="state === 'error'" class="m-tile__state m-tile__state--error" @click.stop="retry">
        <i class="material-icons">refresh</i>
      </span>
      <span v-else-if="isDone" class="m-tile__state m-tile__state--ok">
        <i class="material-icons">check_circle</i>
      </span>
    </button>

    <button v-if="!thumbUrl && !notAvailable" class="m-tile__na-btn" @click="$emit('not-available')">
      {{ $t("returns.photos.markNotAvailable") }}
    </button>
    <button v-else class="m-tile__na-btn" @click="onTap">
      {{ $t("returns.photos.retake") }}
    </button>

    <input ref="fileInput" type="file" accept="image/*" capture="environment" class="m-tile__input" @change="onPicked" />
  </div>
</template>

<script>
// Ein Foto-Slot des Erfassungs-Wizards: Kamera ueber den nativen file-input
// (capture="environment" oeffnet direkt die Rueckkamera, iOS liefert JPEG),
// Alternative "nicht vorhanden". Upload-Status kommt vom Parent.
export default {
  name: "MPhotoTile",
  props: {
    label: { type: String, required: true },
    required: { type: Boolean, default: false },
    thumbUrl: { type: String, default: null },
    notAvailable: { type: Boolean, default: false },
    state: { type: String, default: null }, // null | uploading | done | error
  },
  computed: {
    isDone() {
      return this.notAvailable || (this.thumbUrl && this.state !== "error" && this.state !== "uploading");
    },
  },
  methods: {
    onTap() {
      this.$refs.fileInput.click();
    },
    /** Kamera von aussen oeffnen - z.B. wenn das Label unlesbar war. */
    open() {
      this.onTap();
    },
    retry() {
      this.$emit("retry");
    },
    onPicked(e) {
      const file = e.target.files && e.target.files[0];
      e.target.value = "";
      if (file) this.$emit("picked", file);
    },
  },
};
</script>

<style lang="scss" scoped>
.m-tile {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.14);
  overflow: hidden;
  display: flex;
  flex-direction: column;

  &--done {
    outline: 2px solid #7f915a;
  }
  &--error {
    outline: 2px solid #f44336;
  }

  &__main {
    position: relative;
    border: 0;
    background: none;
    padding: 0;
    cursor: pointer;
    text-align: left;
    display: block;
    width: 100%;
  }

  &__thumb {
    width: 100%;
    height: 110px;
    object-fit: cover;
    display: block;
  }

  &__empty,
  &__na {
    height: 110px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    color: #9e9e9e;
    background: #fafafa;

    i {
      font-size: 34px;
    }
    span {
      font-size: 12px;
    }
  }

  &__na {
    color: #757575;
  }

  &__label {
    display: block;
    font-size: 13px;
    font-weight: 500;
    padding: 8px 10px;
    color: #212121;

    em {
      font-style: normal;
      color: #f44336;
      font-size: 11px;
      margin-left: 4px;
    }
  }

  &__state {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.92);
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 22px;
    }
    &--ok i {
      color: #7f915a;
    }
    &--error i {
      color: #f44336;
    }
    &--busy i {
      color: #757575;
    }
  }

  &__na-btn {
    border: 0;
    border-top: 1px solid #eee;
    background: none;
    color: #757575;
    font-size: 12px;
    padding: 8px;
    cursor: pointer;
  }

  &__input {
    display: none;
  }
}

.m-spin {
  animation: m-rotate 1.2s linear infinite;
}
@keyframes m-rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
